import { selectedViewSelector } from "./selectedViewSelector";
import { filtersFromViewCombiner } from "./filtersFromViewCombiner";
import { RootState } from "../../../../store";

export const viewInstanceTypeFilterSelector = (state: RootState) => {
  const view = selectedViewSelector(state);

  return filtersFromViewCombiner("instance_type", view?.filters);
};
